import type {
    BroadcastConfig,
    IvsRealTimePlayerConfig,
    PlayerConfigCommon,
    StreamingProvider,
} from '$lib/services/streaming/types';

import { StreamProvider, StreamStatus } from '@shared/types/room';

export default class MockProvider implements StreamingProvider {
    private broadcastConfig?: BroadcastConfig;
    private deliveryConfig?: PlayerConfigCommon;

    public getType() {
        return StreamProvider.MockProvider;
    }

    public async startBroadcast(config: BroadcastConfig) {
        this.broadcastConfig = config;
        setTimeout(() => {
            if (this.broadcastConfig) {
                this.broadcastConfig.onEvent(StreamStatus.PeerConnectionEstablished);
            }
        }, 1000);

    }

    public stopBroadcast() {
        this.broadcastConfig?.onEvent(StreamStatus.SdpReceived);
    }

    public startDelivery(config: IvsRealTimePlayerConfig & PlayerConfigCommon): Promise<void> {
        setTimeout(() => {
            this.deliveryConfig = config;
            this.deliveryConfig.video.src = '/video/mock.mp4';
            this.deliveryConfig.video.loop = true;
            this.deliveryConfig.video.play();
        }, 1000);

        return Promise.resolve();
    }

    public stopDelivery() {
        if (this.deliveryConfig) {
            this.deliveryConfig.video.pause();
        }

    }

    public destroy() {
        this.stopDelivery();
        this.stopBroadcast();
    }

    public restartBroadcast(byPlayerHealth = false) {
        if (!byPlayerHealth) {
            this.stopBroadcast();
            if (this.broadcastConfig) {
                this.startBroadcast(this.broadcastConfig);
            }
        } else {
            this.broadcastConfig?.onEvent(StreamStatus.PeerConnectionEstablished);
        }
    }
}